import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { EventAPIData, UserAPIData } from '../../../types/growth-api';
import { QueryKey } from '../../../types/growth-query-key';
import { EventDTO } from '../lib/entities/event';
import { UserDTO } from '../lib/entities/user';

export const useOneOnOneEvent = (eventId: string) => {
	const http = useHttpClient();

	return useQuery({
		queryKey: [QueryKey.Event, eventId],
		queryFn: async () => {
			const eventRes = await http.get<EventAPIData>(`/one_on_ones/events/${eventId}`);
			const event = new EventDTO(eventRes.data);
			const usersRes = await http.get<UserAPIData[]>('user_management/users', {
				params: {
					user_ids: [event.hostId, event.guestId],
				},
			});

			const users = usersRes.data.map((user) => new UserDTO(user));
			event.host = users.find((user) => user.id === event.hostId);
			event.guest = users.find((user) => user.id === event.guestId);

			return event;
		},
	});
};
